import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "check-circle",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.9998 16.2C10.9094 16.2 12.7407 15.4415 14.091 14.0912C15.4412 12.741 16.1998 10.9096 16.1998 9.00005C16.1998 7.09049 15.4412 5.25914 14.091 3.90888C12.7407 2.55862 10.9094 1.80005 8.9998 1.80005C7.09025 1.80005 5.2589 2.55862 3.90864 3.90888C2.55837 5.25914 1.7998 7.09049 1.7998 9.00005C1.7998 10.9096 2.55837 12.741 3.90864 14.0912C5.2589 15.4415 7.09025 16.2 8.9998 16.2ZM12.3361 7.83635C12.5 7.66661 12.5908 7.43927 12.5887 7.20329C12.5867 6.96731 12.492 6.74158 12.3251 6.57471C12.1583 6.40785 11.9325 6.31319 11.6966 6.31114C11.4606 6.30909 11.2332 6.39981 11.0635 6.56375L8.0998 9.52745L6.9361 8.36375C6.76636 8.19981 6.53902 8.10909 6.30304 8.11114C6.06707 8.11319 5.84134 8.20785 5.67447 8.37471C5.5076 8.54158 5.41295 8.76731 5.4109 9.00329C5.40885 9.23927 5.49956 9.46661 5.66351 9.63635L7.4635 11.4363C7.63228 11.6051 7.86116 11.6999 8.0998 11.6999C8.33845 11.6999 8.56733 11.6051 8.7361 11.4363L12.3361 7.83635Z",
			fill: "currentColor"
		})
	})
});
export default SvgCheckCircle;
